module.exports = __webpack_public_path__ + "static/wolf-hall-11bb8024233ade1cd8b271af54bc498b.jpg";